import React, {createRef, useEffect} from "react";
import ReactPlayer from "react-player/youtube";
import SectionTitle from "../SectionTitle";
import {
  DashedLine,
  Video,
  Link,
  Book,
  Film,
  ScrollBar,
  Info,
  VideoPallino,
  Grafiche,
  Lezioni,
  QuizPallino,
  Pallino,
} from "./Icons";
import Footer from "../Footer";
import infograficaUno from "./infografica_1.1.pdf";
import infograficaDue from "./infografica_1.2.pdf";
import quizNoveUno from "./Quiz_1.1_9.pdf";
import quizNoveDue from "./Quiz_1.2_9.pdf";
import quizNoveTre from "./Quiz_1.3_9.pdf";
import quizNoveQuattro from "./Quiz_1.4_9.pdf";
import quizDodiciUno from "./Quiz_1.1_12.pdf";
import quizDodiciDue from "./Quiz_1.2_12.pdf";
import quizDodiciTre from "./Quiz_1.3_12.pdf";
import quizDodiciQuattro from "./Quiz_1.4_12.pdf";
import lezioneDueNove from "./Lezione_1.2_9.pdf";
import lezioneDueDodici from "./Lezione_1.2_12.pdf";
import lezioneTreNove from "./Lezione_1.3_9.pdf";
import lezioneTreDodici from "./Lezione_1.3_12.pdf";
import attestato from "./attestato.pdf";

import {
  Wrap,
  Intro,
  VideoWrapper,
  InfoGraphics,
  Lessons,
  Quizzes,
  Certification,
  Links,
  FiltersTabs,
  FiltersTabList,
  FilterTab,
  FilterTabPanelLesson,
  FilterTabPanelQuiz,
  Space,
  ScrollContainer,
  PallinoWrap,
} from "./styles";

export default function SectionContentImparare(props) {
  const ScrollBarWithRef = React.forwardRef((props, ref) => (
    <div ref={ref}>
      <ScrollBar />
    </div>
  ));
  const scrollRef = createRef(null);

  const imageToShow = (pos) => {
    switch (true) {
      case pos >= 0 && pos < 1237:
        return "info";
      case pos >= 1237 && pos < 1879:
        return "video";
      case pos >= 1879 && pos < 2489:
        return "grafiche";
      case pos >= 2489 && pos < 3975:
        return "lezioni";
      case pos >= 3975 && pos < 4793:
        return "quiz";
      default:
        return "pallino";
    }
  };

  useEffect(() => {
    imageToShow(props.pos);
  }, [props.pos]);

  return (
    <Wrap>
      <ScrollContainer>
        <ScrollBarWithRef ref={scrollRef} />
      </ScrollContainer>
      <PallinoWrap opacity={imageToShow(props.pos)}>
        <Info />
        <VideoPallino />
        <Grafiche />
        <Lezioni />
        <QuizPallino />
        <Pallino />
      </PallinoWrap>
      <Intro>
        <SectionTitle title="INTRODUZIONE" />
        <h2>{props.mainTitleFirstPart}</h2>
        {props.mainTitleSecondPart && <h2>{props.mainTitleSecondPart}</h2>}
        <section>
          <div>
            <article>{props.description}</article>
          </div>
          <div>
            {props.checkPoints.map((c, i) => (
              <span key={i}>
                <svg width="37" height="29">
                  <path
                    d="M32.107 0L37 5.108 14.111 29 0 14.27l4.893-5.107 9.218 9.622z"
                    fill="#F5A462"
                    fillRule="evenodd"
                  />
                </svg>
                {c.toUpperCase()}
              </span>
            ))}
          </div>
        </section>
      </Intro>

      <VideoWrapper>
        <div>
          <SectionTitle title="UN VIDEO PER INIZIARE" />
          <h2>{props.videoTitle}</h2>
        </div>
        <div>
          <ReactPlayer width="100%" height="auto" url="https://youtu.be/z1-5VMvr2Mg" />
        </div>
      </VideoWrapper>

      <InfoGraphics>
        <div>
          <SectionTitle title="DIAMO I NUMERI" />
          <h2>{props.infographicTitle}</h2>
        </div>
        <div>
          <section>
            <a href={infograficaUno} target="_blank" rel="noopener noreferrer" >
              <div></div>
              <button>SCARICA ORA</button>
            </a>
          </section>
          <span />
          <section>
            <a href={infograficaDue} target="_blank" rel="noopener noreferrer" >
              <div></div>
              <button>SCARICA ORA</button>
            </a>
          </section>
        </div>
      </InfoGraphics>

      <Lessons>
        <div>
          <SectionTitle title="PROPOSTE DI LEZIONE" />
          <h2>{props.lessonsTitle}</h2>
          <p>{props.lessonDescription}</p>
          <span>Seleziona la fascia d'età</span>
          <div>
            <FiltersTabs>
              <FiltersTabList>
                <FilterTab>9 - 11 ANNI</FilterTab>
                <FilterTab>12 - 14 ANNI</FilterTab>
              </FiltersTabList>
              <FilterTabPanelLesson>
                <div>
                  <section>
                    <a
                      href="https://view.genial.ly/609e452d163eb00dc475575f/presentation-lez-11-9-11-anni-i-cambiamenti-climatici-nella-storia-della-terra"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a href={lezioneDueNove} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA E L’ATTIVITÀ</button>
                    </a>
                  </section>
                </div>
                <div>
                  <section>
                    <a href={lezioneTreNove} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA E L’ATTIVITÀ</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a
                      href="https://view.genial.ly/609e464ed98b680dbb54a9e9/presentation-lez-14-9-11-anni-tra-mitigazione-e-adattamento"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                </div>
              </FilterTabPanelLesson>
              <FilterTabPanelLesson>
                <div>
                  <section>
                    <a
                      href="https://view.genial.ly/60803180765d060d255b37e6/presentation-lez11-12-14-anni-i-cambiamenti-climatici-nella-storia-della-terra"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a href={lezioneDueDodici} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA E L’ATTIVITÀ</button>
                    </a>
                  </section>
                </div>
                <div>
                  <section>
                    <a href={lezioneTreDodici} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA E L’ATTIVITÀ</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a
                      href="https://view.genial.ly/6086d3df78c7db0da079e5c4/presentation-lez-14-12-14-anni-tra-mitigazione-e-adattamento"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                </div>
              </FilterTabPanelLesson>
            </FiltersTabs>
          </div>
        </div>
      </Lessons>

      <Quizzes>
        <div>
          <SectionTitle title="QUIZ" />
          <h2>{props.quizTitle}</h2>
          <p>{props.quizDescription}</p>
          <span>Seleziona la fascia d'età</span>
          <div>
            <FiltersTabs>
              <FiltersTabList>
                <FilterTab>9 - 11 ANNI</FilterTab>
                <FilterTab>12 - 14 ANNI</FilterTab>
              </FiltersTabList>
              <FilterTabPanelQuiz>
                <div>
                  <DashedLine />
                  <Space />
                  <div>
                    <a href={quizNoveUno} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizNoveUno} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.1 | I cambiamenti climatici nella storia della Terra</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizNoveDue} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizNoveDue} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.2 | Come si studiano i cambiamenti climatici</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizNoveTre} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizNoveTre} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.3 | A lezione di clima per salvare la biodiversità</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizNoveQuattro} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizNoveQuattro} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.4 | Tra mitigazione e adattamento: le risposte ai cambiamenti climatici</p>
                    </a>
                  </div>
                </div>
              </FilterTabPanelQuiz>
              <FilterTabPanelQuiz>
                <div>
                  <DashedLine />
                  <Space />
                  <div>
                    <a href={quizDodiciUno} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizDodiciUno} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.1 | I cambiamenti climatici nella storia della Terra</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizDodiciDue} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizDodiciDue} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.2 | Come si studiano i cambiamenti climatici</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizDodiciTre} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizDodiciTre} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.3 | A lezione di clima per salvare la biodiversità</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizDodiciQuattro} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizDodiciQuattro} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 1.4 | Tra mitigazione e adattamento: le risposte ai cambiamenti climatici</p>
                    </a>
                  </div>
                </div>
              </FilterTabPanelQuiz>
            </FiltersTabs>
          </div>
        </div>
      </Quizzes>

      <Certification>
        <div>
          <SectionTitle title="ATTESTATO" />
          <h2>{props.certificateTitle}</h2>
          <p>{props.certificateDescription}</p>
          <a href={attestato} target="_blank" rel="noopener noreferrer" >
            <button>SCARICA L'ATTESTATO</button>
          </a>
        </div>
      </Certification>

      <Links>
        <div>
          <h2>{props.linksTitle}</h2>
        </div>

        <div>
          <h1>VIDEO</h1>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://media.unito.it/?content=9637" target="_blank" rel="noopener noreferrer">
              <p>
                Come si studia il clima? Dalle ricostruzioni del passato, alle misurazioni di oggi fino ai modelli per
                le previsioni future | Università degli Studi di Torino (2020)
              </p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/3K_rF5corjQ" target="_blank" rel="noopener noreferrer">
              <p>Evidenze scientifiche dei cambiamenti climatici | Mondadori Education (2020)</p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/2c8g-qjN1vc" target="_blank" rel="noopener noreferrer">
              <p>I negoziati sul clima | Italian Climate Network (2017) </p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/W5c48iQqBd0" target="_blank" rel="noopener noreferrer">
              <p>Le carote di ghiaccio | Museo Nazionale dell’Antartide (2020)</p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://www.youtube.com/watch?v=Y9E4A6bAtFQ" target="_blank" rel="noopener noreferrer">
              <p>Le ere glaciali | Geopop (2020)</p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/LJoO6LwR6C4" target="_blank" rel="noopener noreferrer">
              <p>Scienza e tecnologia del clima | Italian Climate Network (2016) </p>
            </a>
          </div>
        </div>
        <div>
          <h1>ARTICOLI E SITI WEB</h1>
          <div>
            <div>
              <Link />
            </div>
            <a href="https://www.italiaclima.org/cose-laccordo-di-parigi/" target="_blank" rel="noopener noreferrer">
              <p>Breve guida all’accordo di Parigi | Italian Climate Network (2018)</p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a
              href="https://www.eea.europa.eu/it/segnali/segnali-2018/articoli/cambiamenti-climatici-e-acqua-2014"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>
                Cambiamenti climatici e acqua - Oceani più caldi, inondazioni e siccità | Agenzia europea dell’ambiente
                (2019)
              </p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a href="https://dinosaurpictures.org/ancient-earth#0" target="_blank" rel="noopener noreferrer">
              <p>Che aspetto aveva la Terra ... anni fa? | Scotese C.R. (in inglese)</p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a href="https://climatekids.nasa.gov/" target="_blank" rel="noopener noreferrer">
              <p>ClimateKids | NASA (in inglese)</p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a
              href="https://climate.nasa.gov/interactives/climate-time-machine"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Climate time machine | NASA (in inglese)</p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a href="https://www.noaa.gov/education/resource-collections" target="_blank" rel="noopener noreferrer">
              <p>Materiali educativi | NOAA (in inglese)</p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a
              href="https://www.istituto-oikos.org/notizie/spillover-e-perdita-di-biodiversita"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>Salute umana e perdita di biodiversità | Istituto Oikos (2020)</p>
            </a>
          </div>
        </div>
        <div>
          <h1>LIBRI E FILM</h1>
          <div>
            <div>
              <Book />
            </div>
            <p>Perché la Terra ha la febbre? | Palazzi E., Taddia F. (2020)</p>
          </div>
          <div>
            <div>
              <Book />
            </div>
            <p>
              Pinguini all’Equatore - Perché non tutto ciò che senti sul clima è vero | Giacomin S., Perri L. (2020)
            </p>
          </div>
          <div>
            <div>
              <Film />
            </div>
            <p>Before the flood - Punto di non ritorno | Fisher Stevens (2016) </p>
          </div>
          <div>
            <div>
              <Film />
            </div>
            <p>Una scomoda verità 2 | Bonni Cohen, Jon Shenk (2017)</p>
          </div>
          <div>
            <div>
              <Film />
            </div>
            <p>Una vita sul nostro Pianeta | David Attenborough (2020)</p>
          </div>
        </div>
      </Links>
      <Footer />
    </Wrap>
  );
}
